import emailjs from "emailjs-com";

const SERVICE_ID = "service_kmuchua";
const TEMPLATE_ID = "template_nxyszu5";
const PUBLIC_KEY = "Hfd1U5kA3SqhndCpc";
const TEMPLATE_ID_OTP = "template_tj5zsvm";

export const sendVerificationEmail = async (data) => {
  // 1. Validate Input
  if (!data || !data.email || !data.token || !data.name) {
    console.error(
      "SendEmail Error: Missing required data (email, name, or token)."
    );
    return { success: false, message: "Internal Error: Missing email data." };
  }

  try {
    // 2. Generate the Verification Link
    // This dynamically gets your site's URL (e.g., http://localhost:3000 or https://myapp.com)
    const baseUrl = window.location.origin;
    const verificationLink = `${baseUrl}/verify?mode=verify&token=${data.token}`;

    // 3. Prepare Template Parameters
    // Ensure these keys match the {{variables}} in your EmailJS Dashboard template
    const templateParams = {
      company_name: data.companyName,
      to_email: data.email,
      to_name: data.name.split(" ")[0], // First Name
      verification_link: verificationLink, // The clickable link
      subject: "Verify Your Email for Your ContactHQ Account",
    };

    // 4. Send the Email
    const result = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      templateParams,
      PUBLIC_KEY
    );

    console.log("Verification Email sent successfully:", result.text);
    return { success: true, message: "Verification email sent successfully." };
  } catch (error) {
    console.error("Error sending verification email:", error);
    return {
      success: false,
      message: "Failed to send verification email. Please try again later.",
    };
  }
};

export const sendOTP = async ({ name, email, otp, otpExpiry }) => {
  if (!email || !name || !otp || !otpExpiry) {
    console.error(
      "Email Error: Missing required data (email, name, otp, otpExpiry)."
    );
    return { success: false, message: "Internal Error: Missing data." };
  }
  try {
    const expiryTime = new Date(
      otpExpiry || Date.now() + 15 * 60 * 1000
    ).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const templateParams = {
      to_name: name.split(" ")[0],
      to_email: email,
      passcode: otp,
      time: expiryTime,
      subject: `Verify Your ContactHQ Account`,
    };
    await emailjs.send(SERVICE_ID, TEMPLATE_ID_OTP, templateParams, PUBLIC_KEY);
    return { success: true, message: "OTP sent successfully." };
  } catch (error) {
    console.error("Error sending OTP email:", error);
    return { success: false, message: "Failed to send OTP. Please try again." };
  }
};
